import { cn } from "@/lib/cn";
import type { ElementType, HTMLAttributes, ReactNode } from "react";

type SerifProps<E extends ElementType = "div"> = {
  as?: E;
  children: ReactNode;
  className?: string;
} & Omit<HTMLAttributes<HTMLElement>, "className" | "children">;

export function Serif<E extends ElementType = "div">({
  as,
  children,
  className,
  ...rest
}: SerifProps<E>) {
  const Tag = (as || "div") as ElementType;
  return (
    <Tag className={cn("font-serif leading-[1.1] tracking-[0.005em] text-ink", className)} {...rest}>
      {children}
    </Tag>
  );
}
